import { defineMessages } from 'react-intl';

export default defineMessages({
  buttonLabel: {
    id: 'app.components.AvailabilityDelete.buttonLabel',
    defaultMessage: 'Delete availability',
  },
  deleteAvailabilityTitle: {
    id: 'app.components.AvailabilityDelete.deleteAvailabilityTitle',
    defaultMessage: 'Delete availability?',
  },
  deleteAvailabilityText: {
    id: 'app.components.AvailabilityDelete.deleteAvailabilityText',
    defaultMessage:
      'If you remove this availability, no further applications will be automatically generated from {date} for the period of the availability. All applications for shifts before that date will be kept.',
  },
  deleteAvailabilityConfirm: {
    id: 'app.components.AvailabilityDelete.deleteAvailabilityConfirm',
    defaultMessage: 'Yes, delete',
  },
  deleteAvailabilityCancel: {
    id: 'app.components.AvailabilityDelete.deleteAvailabilityCancel',
    defaultMessage: 'Cancel',
  },
  deletingAvailabilityFailed: {
    id: 'app.components.AvailabilityDelete.deletingAvailabilityFailed',
    defaultMessage: 'Failed to delete availability',
  },
  deletingAvailabilitySucceeded: {
    id: 'app.components.AvailabilityDelete.deletingAvailabilitySucceeded',
    defaultMessage: 'Successfully deleted availability',
  },
});
